import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Testimonials: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Testimonials</h1>
      <p className="section-description">
        Manage and showcase customer testimonials to build trust and credibility. Control testimonial visibility and content.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Testimonial Management</h3>
              <p className="feature-description">
                Handle testimonials with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Add and edit testimonial details</li>
                <li>Upload testimonial images</li>
                <li>Toggle testimonial visibility (active/inactive)</li>
                <li>Delete individual testimonials</li>
                <li>Bulk delete multiple testimonials</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Testimonial List</h3>
              <p className="feature-description">
                View and manage testimonials in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Name (searchable)</li>
                <li>Content (searchable, truncated to 50 characters)</li>
                <li>Position (searchable)</li>
                <li>Active status (boolean toggle)</li>
                <li>Creation date (sortable, hidden by default)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Testimonial Details</h3>
              <p className="feature-description">
                Edit testimonial information with the following fields:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Name (required, max 255 characters)</li>
                <li>Content (required, max 65535 characters)</li>
                <li>Position (max 255 characters)</li>
                <li>Image (optional)</li>
                <li>Active status toggle</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep testimonials concise and impactful</li>
            <li>Use high-quality images for testimonial photos</li>
            <li>Regularly update testimonial content</li>
            <li>Maintain a good balance of active testimonials</li>
            <li>Use the position field to add credibility to testimonials</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Testimonials; 